import { render, staticRenderFns } from "./templateColorView.vue?vue&type=template&id=8bbcf248&"
import script from "./templateColorView.vue?vue&type=script&lang=ts&"
export * from "./templateColorView.vue?vue&type=script&lang=ts&"
import style0 from "./templateColorView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports